import React from 'react';
import styles from './CartPopup.module.css';

interface CartPopupProps {
  onClose: () => void;
}

const CartPopup: React.FC<CartPopupProps> = ({ onClose }) => {
  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.popup} onClick={(e) => e.stopPropagation()}>
        <button className={styles.closeButton} onClick={onClose}>×</button>
        <h2>Meu Carrinho</h2>
        <p>Aqui estarão os itens do seu carrinho.</p>
      </div>
    </div>
  );
};

export default CartPopup;